import { InteractionRequiredAuthError, LogLevel, PublicClientApplication, SilentRequest } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: (process.env['REACT_APP_MSAL_CLIENTID'] as string),
        authority: (process.env['REACT_APP_MSAL_AUTHORITY'] as string),
        knownAuthorities: [],
        redirectUri: (process.env['REACT_APP_MSAL_REDIRECTURI'] as string),
        postLogoutRedirectUri: (process.env['REACT_APP_MSAL_REDIRECTURI'] as string),
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: false
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                }
            },
            piiLoggingEnabled: false
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0
    }
};

// Login Authentication Parameters
export const loginParameters = {
  scopes: [`${process.env['REACT_APP_MSAL_APICLIENTID']}/.default`],
  forceRefresh: true
}

// Authentication Parameters
export const authenticationParameters = {
  scopes: [`${process.env['REACT_APP_MSAL_APICLIENTID']}/.default`],
  forceRefresh: false
}

// Create an instance of PublicClientApplication
export const msalInstance = new PublicClientApplication(msalConfig);

export const authGetAcc = () => {
  if (msalInstance.getAllAccounts().length > 0){ 
    return msalInstance.getAllAccounts()[0];
  }else{
    return null;
  }
}

export const authWrapper = async () => {
  const silentAuthPars: SilentRequest = {
    ...authenticationParameters,
    account: msalInstance.getAllAccounts()[0],
  };
  //Handle the redirect flows
  const status = await msalInstance.acquireTokenSilent(silentAuthPars).then((resp) => {
    return resp
  }).catch(async (error) => {
    if (error instanceof InteractionRequiredAuthError) {
        // fallback to interaction when silent call fails
        return await msalInstance.acquireTokenPopup(silentAuthPars).then((resp) => {
          return resp
        }).catch(error => {
            console.error(error)
            return null
        });
    }else{
      return null
    }
  });
  if(process.env.NODE_ENV === 'development') {
    console.log(status)
  }
  return status
}